'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BASE_URL = 'broadcast/v1';
function fetchBroadcasts(postId, status = 'SUCCESS') {
  return http.get(`${BASE_URL}/broadcasts`, {
    query: {
      remoteContentId: postId,
      status
    }
  });
}
function fetchStatus(blogId) {
  return http.get(`${BASE_URL}/blog-publish/blogs/${blogId}/status`);
}
function fetch(id) {
  return http.get(`${BASE_URL}/bapCustomization/${PortalIdParser.get()}/${id}`);
}
function save(blogPostGuid, body) {
  const portalId = PortalIdParser.get();
  return http.post(`${BASE_URL}/bapCustomization/${portalId}/${blogPostGuid}`, {
    data: {
      blogPostGuid,
      body,
      portalId
    }
  });
}
export default {
  fetch,
  fetchBroadcasts,
  fetchStatus,
  save
};